// Video URL management for AWS S3/CloudFront
// Updated with S3 URLs for better performance and reliability

// Replace YOUR-CLOUDFRONT-DOMAIN with your actual CloudFront domain
const CLOUDFRONT_DOMAIN = 'dhfbvjfrbuwbt.cloudfront.net';

export const VIDEO_URLS = {
  // Formula 1 videos
  'F1-Access.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/F1-Access.mp4`,
  'F1-TV-Graphics.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/F1-TV-Graphics.mp4`,
  'F1-ui1.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/F1-ui1.mp4`,
  'F1-ui2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/F1-ui2.mp4`,
  
  // Zeekr videos
  'zeekr-video.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/zeekr-video.mp4`,
  
  // Nivea videos
  'NIVEA_Naturally_Good.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/NIVEA_Naturally_Good.mp4`,
  'Nivea-BTS.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/Nivea-BTS.mp4`,
  
  // Volvo Trucks Aero videos
  'AERO-Reveal-Film.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/AERO-Reveal-Film.mp4`,
  'AERO_Final_loop_small.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/AERO_Final_loop_small.mp4`,
  'AERO-Web.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/AERO-Web.mp4`,
  'A.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/A.mp4`,
  'E.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/E.mp4`,
  'R.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/R.mp4`,
  'O.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/O.mp4`,
  
  // Dieter Rams videos
  'RAMS.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/RAMS.mp4`,
  'DiterRams_Anim.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/DiterRams_Anim.mp4`,
  'Diter_TapePlayer.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/Diter_TapePlayer.mp4`,
  'diter-TV.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-TV.mp4`,
  'diter-amplifier.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-amplifier.mp4`,
  'diter-camera.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-camera.mp4`,
  'diter-filmroll.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-filmroll.mp4`,
  'diter-radio2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-radio2.mp4`,
  'diter-radio3.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-radio3.mp4`,
  'diter-vectors_Calculator.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-vectors_Calculator.mp4`,
  'diter-vinyl.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/diter-vinyl.mp4`,
  
  // Volvo Trucks AR videos
  'VolvotrucksAR-video.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/VolvotrucksAR-video.mp4`,
  
  // Nike videos
  'TCP-ads1.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/TCP-ads1.mp4`,
  'TCP-ads2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/TCP-ads2.mp4`,
  'TCP-movie.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/TCP-movie.mp4`,
  
  // Nissan videos
  'Nissan-IDx-VR.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/Nissan-IDx-VR.mp4`,
  'nissan_idx_ui_1.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/nissan_idx_ui_1.mp4`,
  'nissan_idx_ui_2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/nissan_idx_ui_2.mp4`,
  
  // Volvo Rider videos
  'Volvo_Rider_BB.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/Volvo_Rider_BB.mp4`,
  
  // Polestar Engineered videos
  'PolestarEngineered.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/PolestarEngineered.mp4`,

  // Word Play videos
  'TheGreatDictatorSpeech-CharlieChaplin.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/TheGreatDictatorSpeech-CharlieChaplin.mp4`,
};

// Mobile video URLs mapping - same videos optimized for mobile
export const MOBILE_VIDEO_URLS = {
  // Formula 1 videos
  'F1-Access.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/F1-Access-mobile.mp4`,
  'F1-TV-Graphics.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/F1-TV-Graphics-mobile.mp4`,
  'F1-ui1.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/F1-ui1-mobile.mp4`,
  'F1-ui2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/F1-ui2-mobile.mp4`,
  
  // Zeekr videos
  'zeekr-video.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/zeekr-video-mobile.mp4`,
  
  // Nivea videos
  'NIVEA_Naturally_Good.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/NIVEA_Naturally_Good-mobile.mp4`,
  'Nivea-BTS.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/Nivea-BTS-mobile.mp4`,
  
  // Volvo Trucks Aero videos
  'AERO-Reveal-Film.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/AERO-Reveal-Film-mobile.mp4`,
  'AERO_Final_loop_small.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/AERO_Final_loop_small-mobile.mp4`,
  'AERO-Web.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/AERO-Web-mobile.mp4`,
  'A.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/A-mobile.mp4`,
  'E.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/E-mobile.mp4`,
  'R.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/R-mobile.mp4`,
  'O.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/O-mobile.mp4`,
  
  // Dieter Rams videos
  'RAMS.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/RAMS-mobile.mp4`,
  'DiterRams_Anim.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/DiterRams_Anim-mobile.mp4`,
  'Diter_TapePlayer.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/Diter_TapePlayer-mobile.mp4`,
  'diter-TV.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-TV-mobile.mp4`,
  'diter-amplifier.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-amplifier-mobile.mp4`,
  'diter-camera.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-camera-mobile.mp4`,
  'diter-filmroll.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-filmroll-mobile.mp4`,
  'diter-radio2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-radio2-mobile.mp4`,
  'diter-radio3.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-radio3-mobile.mp4`,
  'diter-vectors_Calculator.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-vectors_Calculator-mobile.mp4`,
  'diter-vinyl.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/diter-vinyl-mobile.mp4`,
  
  // Volvo Trucks AR videos
  'VolvotrucksAR-video.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/VolvotrucksAR-video-mobile.mp4`,
  
  // Nike videos
  'TCP-ads1.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/TCP-ads1-mobile.mp4`,
  'TCP-ads2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/TCP-ads2-mobile.mp4`,
  'TCP-movie.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/TCP-movie-mobile.mp4`,
  
  // Nissan videos
  'Nissan-IDx-VR.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/Nissan-IDx-VR-mobile.mp4`,
  'nissan_idx_ui_1.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/nissan_idx_ui_1-mobile.mp4`,
  'nissan_idx_ui_2.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/nissan_idx_ui_2-mobile.mp4`,
  
  // Volvo Rider videos
  'Volvo_Rider_BB.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/Volvo_Rider_BB-mobile.mp4`,
  
  // Polestar Engineered videos
  'PolestarEngineered.mp4': `https://${CLOUDFRONT_DOMAIN}/Videos/mobile-videos/PolestarEngineered-mobile.mp4`,
};

// Helper function to get video URL
export const getVideoUrl = (filename: string, isMobile?: boolean): string => {
  if (isMobile && MOBILE_VIDEO_URLS[filename as keyof typeof MOBILE_VIDEO_URLS]) {
    return MOBILE_VIDEO_URLS[filename as keyof typeof MOBILE_VIDEO_URLS];
  }
  // Always return desktop video URL if it exists, otherwise fallback to original src
  return VIDEO_URLS[filename as keyof typeof VIDEO_URLS] || filename;
};

// Helper function to get mobile video URL specifically
export const getMobileVideoUrl = (filename: string): string => {
  return MOBILE_VIDEO_URLS[filename as keyof typeof MOBILE_VIDEO_URLS] || getVideoUrl(filename);
};

// Helper function to check if video is hosted on S3/CloudFront
export const isS3Video = (filename: string): boolean => {
  return VIDEO_URLS[filename as keyof typeof VIDEO_URLS]?.includes('cloudfront.net') || false;
};

// Helper function to check if mobile video exists
export const hasMobileVideo = (filename: string): boolean => {
  return MOBILE_VIDEO_URLS[filename as keyof typeof MOBILE_VIDEO_URLS] !== undefined;
};
